<template>
  <a :href="result.detailPage" class="search-product" @click="handlerClick">
    <span class="search-product__image">
      <img v-if="result.picture" :src="result.picture.src" :alt="result.picture.alt" />
      <GiaPhoto v-if="result.isGia" />
    </span>
    <span class="search-product__description">
      <span class="search-product__text">
        <span class="search-product__name">
          {{ result.type }}
        </span>
        <DefCollection v-if="result.collection">
          {{ result.collection.name }}
        </DefCollection>
      </span>
      <span v-if="result.price" class="search-product-prices">
        <span class="search-product-prices__left">
          <DefPrice v-if="result.price">
            {{ result.price.printPrice || result.price.price }}
          </DefPrice>
          <DefPriceEN> {{ result?.price?.printPriceEUR }} </DefPriceEN>
          <DefSale v-if="result.price.printDiscountPercent">
            {{ result.price.printDiscountPercent }}
          </DefSale>
        </span>
        <span>
          <DefPriceOld
            v-if="
              result.price.price &&
              result.price.priceOld &&
              +result.price.price !== +result.price.priceOld
            "
          >
            {{ result.price.printPriceOld }}
          </DefPriceOld>
        </span>
      </span>
    </span>
  </a>
</template>

<script>
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import DefCollection from '@components/Def/DefCollection/DefCollection.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import DefPriceEN from '@components/Def/DefPrice/DefPriceEN.vue';
import DefSale from '@components/Def/DefSale/DefSale.vue';
import Analytics from '@/utils/Analytics/Analytics';

export default {
  name: 'SearchProduct',
  components: {
    GiaPhoto,
    DefCollection,
    DefPrice,
    DefPriceOld,
    DefPriceEN,
    DefSale,
  },
  props: ['result'],
  methods: {
    handlerClick() {
      Analytics.clickOnProduct(this.result);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-product {
  display: grid;
  grid-template-columns: 48px 1fr;
  grid-column-gap: 16px;
  background-color: #fff;
  padding: 8px;
  border: 1px solid #e0e0e0;
  transition: 0.2s linear border-color;
  @include point-md {
    grid-column-gap: 16px;
    grid-template-columns: 60px 1fr;
    align-items: center;
  }
  &:hover {
    border-color: #3f3f44;
  }
  &__image {
    max-width: 100%;
    max-height: 100%;
    position: relative;
    align-self: self-start;
  }
  &__description {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 15px 0;
    gap: 12px;
    @include point-md {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    @include point-lg {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  &__name {
    font-weight: 500;
    font-size: rem(16);
    margin-bottom: 4px;
    text-transform: uppercase;
  }
  &__text {
    display: flex;
    flex-direction: column;
  }
  :deep(.def-price-old) {
    color: #5f5f67;
    font-size: 12px;
    margin-left: 8px;
  }
  :deep(.def-sale) {
    margin-top: 4px;
  }
  :deep(.gia-photo) {
    position: absolute;
    right: 0;
    bottom: 0;
    max-width: 30px;
  }
}
.search-product-prices {
  display: flex;
  flex-shrink: 0;
  gap: 4px;
  @include point-lg {
    gap: 8px;
  }
  &__left {
    display: flex;
    flex-direction: column;
  }
}
</style>
